import React from "react";
import { Tooltip } from "../../text/Tooltip";

export const FeatureButton = ({
  feature,
  description,
  onClick,
  selected,
  colorClass = "style-primary",
}) => {
  const button = (
    <button
      onClick={onClick}
      className={`min-h-[7.5rem] h-full w-full flex flex-col justify-between items-center
        font-inter text-style-text-dark text-sm shadow-md rounded-lg border border-style-border bg-white transition-all
        ${selected ? `ring-2 ring-${colorClass} border-${colorClass}` : "hover:bg-style-bg"}
      `}
    >
      <div className="flex-1 flex items-center justify-center w-full px-4 py-3 text-center break-words">
        {feature}
      </div>
    </button>
  );

  if (!description?.trim()) {
    return button;
  }

  return <Tooltip content={description}>{button}</Tooltip>;
};
